import { Auth } from '@nackle/bridge';
import { idURL } from 'endpoints';
import { GOLD_COMPANY_ID } from '../app/constants';

const auth = new Auth( {
    authority: idURL
    
   //un comment for local deployment
    //authority: idURL,
    // companyId:'2eddede7-12e0-493a-ba36-3940b96b1cac'

    
} );

export default auth;

export function authRequestMiddleware ( url, options = {} ) {
    if ( !auth || !auth.state || !auth.state.claims ) {
        return;
    }

    const companyId = auth.state.claims.company_id;
    options.headers = {
        ...( options.headers || {} ),
        'company-id': companyId,
        'x-company-id': companyId,
        'person-id': auth.state.claims.person_id
    };

    const accessToken = auth.state.access_token;
    if ( accessToken ) {
        options.headers.authorization = `Bearer ${ accessToken }`;
    }
}

export function authRouteMiddleware( action, nextRoute, prevRoute ) {
    // we aren't signed in yet, so continue
    if ( !auth.state.access_token ) {
        return action.ok();
    }

    let nextCompanyId = nextRoute?.state?.params?.companyId;

    // if the next companyId is the same as the auth state companyId, continue
    if ( !nextCompanyId ) {
        nextCompanyId = GOLD_COMPANY_ID;
    }

    if ( nextCompanyId === auth.state.claims.company_id ) {
        return action.ok();
    }

    if ( nextCompanyId ) {
        // switch to the new company
        auth.delegate( nextCompanyId ).then( () => {
            action.ok();
        } ).catch ( err => {
            console.error( err );
        } );

    } else {
        action.ok();
    }
}
